import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useClearLocalStorage } from "../hooks";

import ImgLogo from "../../images/logo.jpg";

import { classNames } from "primereact/utils";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";

export default function FrontHeader({ LayoutCss }) {
  const route_navigate = useNavigate();
  const redux_user = useSelector((state) => state.user);
  const clearLocalStorage = useClearLocalStorage();
  // 是否顯示 個人資料
  const overlay_setting = useRef(null);

  // 登出
  const logout = () => {
    clearLocalStorage();
    route_navigate("/login");
  };

  return (
    <>
      <div
        className={classNames(
          "sticky top-0 bg-white shadow-2",
          LayoutCss["layout-front-head"]
        )}
      >
        <div className="flex align-items-center px-2">
          <img
            src={ImgLogo}
            alt="logo"
            className="flex-shrink-0 w-3rem mr-2 cursor-pointer"
            onClick={() => route_navigate("/member")}
          />
          <h2
            className="cursor-pointer"
            onClick={() => route_navigate("/member")}
          >
            長庚護心
          </h2>

          <span className="text-main ml-auto">
            使用者：{redux_user.userDetail?.name}
          </span>

          {/* <Button
            className="p-button-main p-button-sm w-auto px-2 py-1 ml-2"
            // icon="pi pi-cog"
            label="個人資料"
            onClick={() => route_navigate("/member/setting")}
          /> */}

          <Button
            className="p-button-main p-button-sm w-auto px-2 py-1 ml-2"
            // icon="pi pi-sign-out"
            label="登出"
            onClick={() => logout()}
          />
        </div>
      </div>

      <OverlayPanel
        className="w-15rem mt-4 ml-4 p-0 overflow-y-auto"
        ref={overlay_setting}
      >
        <div className="text-center">
          <div
            className="text-main text-lg font-bold hover:bg-green-50 cursor-pointer py-2 transition-all transition-duration-150 transition-ease-in-out"
            onClick={(e) => {
              overlay_setting.current.toggle(e);
              route_navigate("/member/setting/profile");
            }}
          >
            基本資料
          </div>
          <div
            className="text-main text-lg font-bold hover:bg-green-50 cursor-pointer py-2 transition-all transition-duration-150 transition-ease-in-out"
            onClick={(e) => {
              overlay_setting.current.toggle(e);
              route_navigate("/member/setting/dangerous");
            }}
          >
            危險因素評估
          </div>
          <div
            className="text-main text-lg font-bold hover:bg-green-50 cursor-pointer py-2 transition-all transition-duration-150 transition-ease-in-out"
            onClick={(e) => {
              overlay_setting.current.toggle(e);
              route_navigate("/member/setting/target");
            }}
          >
            個人目標
          </div>
          <div
            className="text-main text-lg font-bold hover:bg-green-50 cursor-pointer py-2 transition-all transition-duration-150 transition-ease-in-out"
            onClick={(e) => {
              overlay_setting.current.toggle(e);
              route_navigate("/member/setting/privacy");
            }}
          >
            隱私權及網站安全政策
          </div>
          <div
            className="text-main text-lg font-bold hover:bg-green-50 cursor-pointer py-2 transition-all transition-duration-150 transition-ease-in-out"
            onClick={(e) => {
              overlay_setting.current.toggle(e);
              route_navigate("/member/setting/security");
            }}
          >
            個資安全聲明
          </div>
        </div>
      </OverlayPanel>
    </>
  );
}
